export enum PagerMode {
  page = 'page',
  offset = 'offset'
}
